// PadelGems admin auth utilities.
// Tokens are kept in sessionStorage (cleared on tab close) rather than localStorage
// to reduce persistence-across-sessions risk. In a future iteration these should be
// migrated to httpOnly cookies with CSRF protection. Client-side is inherently
// vulnerable to XSS; we mitigate that by validating JWT expiry before trusting the token.
//
// This module depends on ./tokenStore for storage and on ./api for network calls.
// It is NOT imported by api.js — breaking the previous circular dependency.
import { api } from './api';
import { getToken, setSession, clearSession, getAdminEmail } from './tokenStore';
import { logger } from './logger';

/** Decode a JWT payload (base64url) without verifying its signature. */
const decodeJwt = (token) => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized + '=='.slice((normalized.length + 2) % 4);
    return JSON.parse(atob(padded));
  } catch (err) {
    logger.warn('Failed to decode JWT', err);
    return null;
  }
};

const isExpired = (token) => {
  const payload = decodeJwt(token);
  if (!payload || typeof payload.exp !== 'number') return true;
  // exp is seconds since epoch
  return Date.now() >= payload.exp * 1000;
};

export { getToken };

export const isAuthed = () => {
  const t = getToken();
  if (!t) return false;
  if (isExpired(t)) {
    logout();
    return false;
  }
  return true;
};

export const login = async (email, password) => {
  const { data } = await api.post('/auth/login', { email, password });
  setSession(data.token, data.email);
  return data;
};

export const logout = () => {
  clearSession();
};

export const currentAdminEmail = () => getAdminEmail();
